import api from './index'

const resource = 'changelog'

export default {
  getChangelog () {
    return api.get(resource)
  }
}
